var _g, _rect, _path, _g2, _rect2, _path2, _g3, _rect3, _path3, _g4, _rect4, _path4, _g5, _rect5, _g6, _rect6, _path5, _g7, _rect7, _path6, _g8, _rect8, _path7, _g9, _rect9, _g10, _rect10, _path8, _g11, _rect11, _path9, _g12, _rect12, _path10, _g13, _rect13, _path11, _g14, _rect14, _path12, _g15, _rect15, _path13, _g16, _rect16, _path14, _g17, _rect17, _path15, _g18, _rect18, _path16, _g19, _rect19, _g20, _rect20, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 223,
    viewBox: "0 0 276 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.6989,
    y: 10.6989,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint0_linear_77_605)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8485 33.6279C29.6042 34.9812 28.2697 35.6578 25.8639 35.6578C23.4017 35.6578 22.0861 34.9812 21.8981 33.6279L20.075 20.7344H24.4919L25.6384 30.5455C25.6948 30.9778 26.0331 31.1845 26.6721 31.1845C27.2923 31.1845 27.6495 30.9778 27.7058 30.5455L28.6456 24.0612C28.7772 23.2154 29.4538 22.7831 30.6755 22.7831C31.8972 22.7831 32.5926 23.2342 32.7242 24.1364L33.7203 30.5455C33.7767 30.9778 34.1338 31.1845 34.754 31.1845C35.3931 31.1845 35.7314 30.9778 35.7878 30.5455L36.8215 20.7344H41.3323L39.434 33.6279C39.2273 34.9812 37.9116 35.6578 35.4683 35.6578C33.0625 35.6578 31.728 34.9812 31.4837 33.6279L30.6755 29.1171L29.8485 33.6279Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.2531,
    y: 6,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.9519,
    y: 10.6989,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint1_linear_77_605)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1015 33.6279C82.8572 34.9812 81.5227 35.6578 79.117 35.6578C76.6548 35.6578 75.3391 34.9812 75.1512 33.6279L73.3281 20.7344H77.7449L78.8914 30.5455C78.9478 30.9778 79.2861 31.1845 79.9252 31.1845C80.5454 31.1845 80.9025 30.9778 80.9589 30.5455L81.8987 24.0612C82.0302 23.2154 82.7068 22.7831 83.9285 22.7831C85.1502 22.7831 85.8456 23.2342 85.9772 24.1364L86.9734 30.5455C87.0297 30.9778 87.3868 31.1845 88.0071 31.1845C88.6461 31.1845 88.9844 30.9778 89.0408 30.5455L90.0746 20.7344H94.5854L92.6871 33.6279C92.4803 34.9812 91.1647 35.6578 88.7213 35.6578C86.3155 35.6578 84.9811 34.9812 84.7367 33.6279L83.9285 29.1171L83.1015 33.6279Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.506,
    y: 6,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 119.205,
    y: 10.6989,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint2_linear_77_605)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.354 33.6279C136.11 34.9812 134.776 35.6578 132.37 35.6578C129.908 35.6578 128.592 34.9812 128.404 33.6279L126.581 20.7344H130.998L132.144 30.5455C132.201 30.9778 132.539 31.1845 133.178 31.1845C133.798 31.1845 134.155 30.9778 134.212 30.5455L135.152 24.0612C135.283 23.2154 135.96 22.7831 137.181 22.7831C138.403 22.7831 139.099 23.2342 139.23 24.1364L140.226 30.5455C140.283 30.9778 140.64 31.1845 141.26 31.1845C141.899 31.1845 142.237 30.9778 142.294 30.5455L143.327 20.7344H147.838L145.94 33.6279C145.733 34.9812 144.418 35.6578 141.974 35.6578C139.568 35.6578 138.234 34.9812 137.99 33.6279L137.181 29.1171L136.354 33.6279Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.759,
    y: 6,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 172.458,
    y: 10.6989,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint3_linear_77_605)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.608 33.6279C189.363 34.9812 188.029 35.6578 185.623 35.6578C183.161 35.6578 181.845 34.9812 181.657 33.6279L179.834 20.7344H184.251L185.397 30.5455C185.454 30.9778 185.792 31.1845 186.431 31.1845C187.051 31.1845 187.408 30.9778 187.465 30.5455L188.405 24.0612C188.536 23.2154 189.213 22.7831 190.435 22.7831C191.656 22.7831 192.352 23.2342 192.483 24.1364L193.479 30.5455C193.536 30.9778 193.893 31.1845 194.513 31.1845C195.152 31.1845 195.49 30.9778 195.547 30.5455L196.581 20.7344H201.091L199.193 33.6279C198.986 34.9812 197.671 35.6578 195.227 35.6578C192.822 35.6578 191.487 34.9812 191.243 33.6279L190.435 29.1171L189.608 33.6279Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.012,
    y: 6,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 225.711,
    y: 10.6989,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint4_linear_77_605)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 59.2531,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6989,
    y: 63.9519,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint5_linear_77_605)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8485 86.881C29.6042 88.2342 28.2697 88.9109 25.8639 88.9109C23.4017 88.9109 22.0861 88.2342 21.8981 86.881L20.075 73.9875H24.4919L25.6384 83.7986C25.6948 84.2309 26.0331 84.4376 26.6721 84.4376C27.2923 84.4376 27.6495 84.2309 27.7058 83.7986L28.6456 77.3142C28.7772 76.4684 29.4538 76.0362 30.6755 76.0362C31.8972 76.0362 32.5926 76.4872 32.7242 77.3894L33.7203 83.7986C33.7767 84.2309 34.1338 84.4376 34.754 84.4376C35.3931 84.4376 35.7314 84.2309 35.7878 83.7986L36.8215 73.9875H41.3323L39.434 86.881C39.2273 88.2342 37.9116 88.9109 35.4683 88.9109C33.0625 88.9109 31.728 88.2342 31.4837 86.881L30.6755 82.3701L29.8485 86.881Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.2531,
    y: 59.2531,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 65.9519,
    y: 63.9519,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint6_linear_77_605)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1214 78.893L81.8958 80.1899C81.8395 80.5094 81.9146 80.7537 82.0838 80.9229C82.253 81.0921 82.6477 81.186 83.2867 81.186C83.8881 81.186 84.3016 81.1109 84.5084 80.9417C84.7151 80.7725 84.7903 80.5282 84.7339 80.1899L84.546 78.893C84.4896 78.4795 84.0761 78.2728 83.3431 78.2728C82.6101 78.2728 82.1966 78.4795 82.1214 78.893ZM79.584 75.8294C79.9411 74.4762 81.2004 73.7995 83.3619 73.7995C85.5421 73.7995 86.8014 74.4762 87.1585 75.8294L90.504 88.7229H86.0872L85.6361 85.9224C85.5045 85.0766 84.7715 84.6631 83.4558 84.6631C82.1402 84.6631 81.4072 85.0766 81.238 85.9224L80.693 88.7229H76.2009L79.584 75.8294Z",
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.506,
    y: 59.2531,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 119.205,
    y: 63.9519,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint7_linear_77_605)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.354 86.881C136.11 88.2342 134.776 88.9109 132.37 88.9109C129.908 88.9109 128.592 88.2342 128.404 86.881L126.581 73.9875H130.998L132.144 83.7986C132.201 84.2309 132.539 84.4376 133.178 84.4376C133.798 84.4376 134.155 84.2309 134.212 83.7986L135.152 77.3142C135.283 76.4684 135.96 76.0362 137.181 76.0362C138.403 76.0362 139.099 76.4872 139.23 77.3894L140.226 83.7986C140.283 84.2309 140.64 84.4376 141.26 84.4376C141.899 84.4376 142.237 84.2309 142.294 83.7986L143.327 73.9875H147.838L145.94 86.881C145.733 88.2342 144.418 88.9109 141.974 88.9109C139.568 88.9109 138.234 88.2342 137.99 86.881L137.181 82.3701L136.354 86.881Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.759,
    y: 59.2531,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 172.458,
    y: 63.9519,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint8_linear_77_605)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.012,
    y: 59.2531,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 225.711,
    y: 63.9519,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint9_linear_77_605)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M242.861 86.881C242.616 88.2342 241.282 88.9109 238.876 88.9109C236.414 88.9109 235.098 88.2342 234.91 86.881L233.087 73.9875H237.504L238.65 83.7986C238.707 84.2309 239.045 84.4376 239.684 84.4376C240.304 84.4376 240.662 84.2309 240.718 83.7986L241.658 77.3142C241.789 76.4684 242.466 76.0362 243.688 76.0362C244.909 76.0362 245.605 76.4872 245.736 77.3894L246.732 83.7986C246.789 84.2309 247.146 84.4376 247.766 84.4376C248.405 84.4376 248.743 84.2309 248.8 83.7986L249.834 73.9875H254.344L252.446 86.881C252.239 88.2342 250.924 88.9109 248.48 88.9109C246.075 88.9109 244.74 88.2342 244.496 86.881L243.688 82.3701L242.861 86.881Z",
    fill: "white"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 112.506,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#474785"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6989,
    y: 117.205,
    width: 37.6024,
    height: 37.6024,
    rx: 7.83133,
    fill: "url(#paint10_linear_77_605)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8683 132.146L28.6428 133.443C28.5864 133.762 28.6616 134.007 28.8307 134.176C28.9999 134.345 29.3946 134.439 30.0336 134.439C30.6351 134.439 31.0486 134.364 31.2553 134.195C31.4621 134.025 31.5373 133.781 31.4809 133.443L31.2929 132.146C31.2365 131.732 30.823 131.526 30.09 131.526C29.357 131.526 28.9435 131.732 28.8683 132.146ZM26.331 129.082C26.6881 127.729 27.9474 127.052 30.1088 127.052C32.2891 127.052 33.5483 127.729 33.9054 129.082L37.251 141.976H32.8341L32.383 139.175C32.2515 138.33 31.5185 137.916 30.2028 137.916C28.8871 137.916 28.1541 138.33 27.985 139.175L27.4399 141.976H22.9479L26.331 129.082Z",
    fill: "white"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.2531,
    y: 112.506,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#474785"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 65.9519,
    y: 117.205,
    width: 37.6024,
    height: 37.6024,
    rx: 7.83133,
    fill: "url(#paint11_linear_77_605)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2347 131.545L83.5022 131.526C82.1489 131.507 81.4535 131.939 81.3971 132.785L81.1904 135.773C81.134 136.619 81.2655 137.145 81.5475 137.352C81.8294 137.54 82.2993 137.653 82.9571 137.672L85.4193 137.785V136.638C85.4193 135.943 85.626 135.416 86.0583 135.097C86.4718 134.777 86.9417 134.608 87.4867 134.608C88.013 134.608 88.4829 134.796 88.9152 135.191C89.3287 135.585 89.5542 136.055 89.5918 136.638L89.9865 142.277L83.427 142.314C80.8521 142.333 79.0289 141.769 77.9388 140.623C76.8487 139.476 76.4164 138.01 76.6419 136.187L77.0554 132.841C77.5253 128.988 79.7243 127.052 83.6337 127.052L89.2159 127.071L89.2347 131.545Z",
    fill: "white"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.506,
    y: 112.506,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#474785"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 119.205,
    y: 117.205,
    width: 37.6024,
    height: 37.6024,
    rx: 7.83133,
    fill: "url(#paint12_linear_77_605)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.329 131.545L137.683 131.526C136.311 131.507 135.615 131.845 135.597 132.503C135.578 132.898 135.785 133.086 136.217 133.105L138.679 133.123C139.187 133.142 139.562 133.274 139.863 133.518C140.126 133.762 140.277 134.119 140.277 134.571C140.277 135.022 140.164 135.36 139.938 135.585C139.713 135.83 139.299 135.961 138.679 135.98L135.897 136.055C135.503 136.074 135.352 136.262 135.409 136.657C135.446 136.901 135.54 137.127 135.709 137.333C135.954 137.615 137.157 137.766 139.318 137.785L142.269 137.803L142.288 142.277L137.608 142.314C133.04 142.314 130.747 140.623 130.747 137.221C130.747 136.901 130.766 136.544 130.823 136.187L131.217 132.841C131.687 128.97 133.886 127.034 137.814 127.052L141.329 127.071V131.545Z",
    fill: "white"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.759,
    y: 112.506,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 172.458,
    y: 117.205,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint13_linear_77_605)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M183.299 141.976L183.713 134.345C183.75 133.725 183.957 133.217 184.352 132.86C184.746 132.503 185.235 132.315 185.837 132.315C186.419 132.315 186.908 132.465 187.303 132.766C187.509 132.935 187.66 133.142 187.754 133.424L190.423 133.405C191.362 133.405 191.832 133.067 191.813 132.371V132.353C191.795 131.77 191.362 131.469 190.498 131.488L184.051 131.545L184.07 127.071L189.652 127.052H189.69H189.727C193.543 127.034 195.629 128.349 195.986 130.981C196.418 134.345 195.572 136.375 193.449 137.07L197.038 141.976H191.889L188.731 137.239L187.885 137.221L187.998 141.976H183.299Z",
    fill: "white"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.012,
    y: 112.506,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 225.711,
    y: 117.205,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint14_linear_77_605)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M241.88 132.146L241.655 133.443C241.598 133.762 241.674 134.007 241.843 134.176C242.012 134.345 242.407 134.439 243.046 134.439C243.647 134.439 244.061 134.364 244.267 134.195C244.474 134.025 244.549 133.781 244.493 133.443L244.305 132.146C244.249 131.732 243.835 131.526 243.102 131.526C242.369 131.526 241.956 131.732 241.88 132.146ZM239.343 129.082C239.7 127.729 240.959 127.052 243.121 127.052C245.301 127.052 246.56 127.729 246.918 129.082L250.263 141.976H245.846L245.395 139.175C245.264 138.33 244.531 137.916 243.215 137.916C241.899 137.916 241.166 138.33 240.997 139.175L240.452 141.976H235.96L239.343 129.082Z",
    fill: "white"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 165.759,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6989,
    y: 170.458,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint15_linear_77_605)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6289 184.591C25.065 184.591 24.614 184.384 24.2756 183.989C23.9561 183.576 23.787 183.068 23.787 182.486C23.787 181.884 23.9185 181.396 24.2005 181.02C24.4636 180.625 24.9335 180.437 25.6289 180.418L37.3195 180.155V184.704L32.959 184.666L33.1658 195.229H28.6173L28.7113 184.628L25.6289 184.591Z",
    fill: "white"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.2531,
    y: 165.759,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 65.9519,
    y: 170.458,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint16_linear_77_605)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1015 193.387C82.8572 194.74 81.5227 195.417 79.117 195.417C76.6548 195.417 75.3391 194.74 75.1512 193.387L73.3281 180.493H77.7449L78.8914 190.305C78.9478 190.737 79.2861 190.944 79.9252 190.944C80.5454 190.944 80.9025 190.737 80.9589 190.305L81.8987 183.82C82.0302 182.974 82.7068 182.542 83.9285 182.542C85.1502 182.542 85.8456 182.993 85.9772 183.895L86.9734 190.305C87.0297 190.737 87.3868 190.944 88.0071 190.944C88.6461 190.944 88.9844 190.737 89.0408 190.305L90.0746 180.493H94.5854L92.6871 193.387C92.4803 194.74 91.1647 195.417 88.7213 195.417C86.3155 195.417 84.9811 194.74 84.7367 193.387L83.9285 188.876L83.1015 193.387Z",
    fill: "white"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.506,
    y: 165.759,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 119.205,
    y: 170.458,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint17_linear_77_605)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.354 193.387C136.11 194.74 134.776 195.417 132.37 195.417C129.908 195.417 128.592 194.74 128.404 193.387L126.581 180.493H130.998L132.144 190.305C132.201 190.737 132.539 190.944 133.178 190.944C133.798 190.944 134.155 190.737 134.212 190.305L135.152 183.82C135.283 182.974 135.96 182.542 137.181 182.542C138.403 182.542 139.099 182.993 139.23 183.895L140.226 190.305C140.283 190.737 140.64 190.944 141.26 190.944C141.899 190.944 142.237 190.737 142.294 190.305L143.327 180.493H147.838L145.94 193.387C145.733 194.74 144.418 195.417 141.974 195.417C139.568 195.417 138.234 194.74 137.99 193.387L137.181 188.876L136.354 193.387Z",
    fill: "white"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.759,
    y: 165.759,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 172.458,
    y: 170.458,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint18_linear_77_605)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_77_605)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.012,
    y: 165.759,
    width: 46.9879,
    height: 46.9879,
    rx: 12.5301,
    fill: "#666672"
  }))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 225.711,
    y: 170.458,
    width: 37.5904,
    height: 37.5904,
    rx: 7.83133,
    fill: "url(#paint19_linear_77_605)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M242.861 193.387C242.616 194.74 241.282 195.417 238.876 195.417C236.414 195.417 235.098 194.74 234.91 193.387L233.087 180.493H237.504L238.65 190.305C238.707 190.737 239.045 190.944 239.684 190.944C240.304 190.944 240.662 190.737 240.718 190.305L241.658 183.82C241.789 182.974 242.466 182.542 243.688 182.542C244.909 182.542 245.605 182.993 245.736 183.895L246.732 190.305C246.789 190.737 247.146 190.944 247.766 190.944C248.405 190.944 248.743 190.737 248.8 190.305L249.834 180.493H254.344L252.446 193.387C252.239 194.74 250.924 195.417 248.48 195.417C246.075 195.417 244.74 194.74 244.496 193.387L243.688 188.876L242.861 193.387Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_77_605",
    x: 0,
    y: 0,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_77_605",
    x: 53.2531,
    y: 0,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_77_605",
    x: 106.506,
    y: 0,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_77_605",
    x: 159.759,
    y: 0,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_77_605",
    x: 213.012,
    y: 0,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_77_605",
    x: 0,
    y: 53.2531,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_77_605",
    x: 53.2531,
    y: 53.2531,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_77_605",
    x: 106.506,
    y: 53.2531,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_77_605",
    x: 159.759,
    y: 53.2531,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_77_605",
    x: 213.012,
    y: 53.2531,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_77_605",
    x: 0,
    y: 106.506,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_77_605",
    x: 53.2531,
    y: 106.506,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_77_605",
    x: 106.506,
    y: 106.506,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_77_605",
    x: 159.759,
    y: 106.506,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_77_605",
    x: 213.012,
    y: 106.506,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_77_605",
    x: 0,
    y: 159.759,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_77_605",
    x: 53.2531,
    y: 159.759,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_77_605",
    x: 106.506,
    y: 159.759,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_77_605",
    x: 159.759,
    y: 159.759,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_77_605",
    x: 213.012,
    y: 159.759,
    width: 62.9879,
    height: 62.9879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.322222 0 0 0 0 0.425333 0 0 0 0 0.483333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_605",
    x1: 31.494,
    y1: 10.6989,
    x2: 31.494,
    y2: 48.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_77_605",
    x1: 84.7471,
    y1: 10.6989,
    x2: 84.7471,
    y2: 48.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_77_605",
    x1: 138,
    y1: 10.6989,
    x2: 138,
    y2: 48.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_77_605",
    x1: 191.253,
    y1: 10.6989,
    x2: 191.253,
    y2: 48.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_77_605",
    x1: 244.506,
    y1: 10.6989,
    x2: 244.506,
    y2: 48.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_77_605",
    x1: 31.494,
    y1: 63.9519,
    x2: 31.494,
    y2: 101.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_77_605",
    x1: 84.7471,
    y1: 63.9519,
    x2: 84.7471,
    y2: 101.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_77_605",
    x1: 138,
    y1: 63.9519,
    x2: 138,
    y2: 101.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_77_605",
    x1: 191.253,
    y1: 63.9519,
    x2: 191.253,
    y2: 101.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_77_605",
    x1: 244.506,
    y1: 63.9519,
    x2: 244.506,
    y2: 101.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_77_605",
    x1: 31.5001,
    y1: 117.205,
    x2: 31.5001,
    y2: 154.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_77_605",
    x1: 84.7531,
    y1: 117.205,
    x2: 84.7531,
    y2: 154.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_77_605",
    x1: 138.006,
    y1: 117.205,
    x2: 138.006,
    y2: 154.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_77_605",
    x1: 191.253,
    y1: 117.205,
    x2: 191.253,
    y2: 154.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_77_605",
    x1: 244.506,
    y1: 117.205,
    x2: 244.506,
    y2: 154.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_77_605",
    x1: 31.494,
    y1: 170.458,
    x2: 31.494,
    y2: 208.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_77_605",
    x1: 84.7471,
    y1: 170.458,
    x2: 84.7471,
    y2: 208.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_77_605",
    x1: 138,
    y1: 170.458,
    x2: 138,
    y2: 208.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_77_605",
    x1: 191.253,
    y1: 170.458,
    x2: 191.253,
    y2: 208.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_77_605",
    x1: 244.506,
    y1: 170.458,
    x2: 244.506,
    y2: 208.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787884"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame2);
export default __webpack_public_path__ + "static/media/game2.74392a2987e086a51037403d717c3180.svg";
export { ForwardRef as ReactComponent };